import isNaN from 'lodash/isNaN';

export const numberFromString = (numberAsString) => {
  if (numberAsString === undefined || numberAsString === null) return numberAsString;
  const number = Number(numberAsString);
  return isNaN(number) ? undefined : number;
};
